import React, { Component } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import Select from "react-select";
import { addApp, updateApp } from '../../../../../../../actions/sceneActions'
import { Card, Button, Row, Col, Form } from "react-bootstrap";
import { DISPLAY_APPS_SUCCESS_SAVE, SUCCESS_TEXT } from "../../messageText";
import { default as DisplayQRCode } from "qrcode.react";
import { NavigationHeader } from "../../../_metronic/layout/components/navigationheader/NavigationHeader";
import { stripTrailingSlash } from "../../../../../../../utils";

const positionOption = [
  { value: "top", label: "Top" },
  { value: "bottom", label: "Bottom" },
];
class QRCode extends Component {
  state = {
    qrURL: "https://taggbox.com",
    stateChanged: false,
    updateApi: false,
    position: 'top',
    qrText: '',
    buttonDis:false,
    loader:false
  };
  onqrLabelChange = (event) => {
    this.setState({ qrText: event.target.value, stateChanged: true });
  };

  onPositionChange = (event) => {
    this.setState({ position: event.value });
  };

  onTextQRCode = (event) => {
    this.setState({ qrURL: event.target.value, stateChanged: true });
  };

  componentDidMount() {
    const { scenes, location } = this.props;
    const { app_data } = scenes.updateSceneData;
    if (app_data) {
      const { qrURL, qrText, position } = app_data;
      if (qrURL && location.pathname.includes('update')) this.setState({ qrURL, qrText, position, updateApi: true });
    }
  }

  onSaveQRCode = (event) => {
    const { param } = this.props;

    const { qrURL, qrText, position, } = this.state;
    if (!qrURL || qrURL === '') {
      Swal.fire({
        title: 'Error',
        text: 'Please enter correct url!',
        type: "error",
        icon: 'error',
        showConfirmButton: false,
        timer: 3000
      });
      return;
    }

    this.setState({buttonDis:true, loader:true})
    this.state.updateApi
      ? this.props.updateApp(
        param.contentMixId,
        this.props.scenes.updateSceneData.id,
        { qrURL, qrText, position, },
        5,
        this.onSaveCallBack
      )
      : this.props.addApp(
        param.contentMixId,
        param.positionID,
        { qrURL, qrText, position, },
        "QR Code",
        4,
        this.onSaveCallBack
      );
  };
  onBack = (event) => {
    const { params } = this.props.match;
    const { pathname } = this.props.location; 
    if (!this.state.stateChanged) {
      this.props.history(stripTrailingSlash(pathname,params))
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text:
        "Your changes have not been saved. Do you want to save before you leave the page?",
      // icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Save",
      cancelButtonText: "Discard Changes",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        this.onSaveQRCode()
      } else if (result.dismiss === "cancel") {
        this.props.history(stripTrailingSlash(pathname,params))
      }
    });
  };
  onSaveCallBack = () => {
    const { params } = this.props.match;
    Swal.fire({
      title: SUCCESS_TEXT,
      text: DISPLAY_APPS_SUCCESS_SAVE,
      type: "success",
      icon: "success",
      showConfirmButton: false,
      timer: 3000,
    }).then((result) => {
      this.setState({buttonDis:false, loader:false})
      this.props.history(`/studio/${params.wallId}`);
    });
  };

  render() {
    const { match } = this.props;
    const { qrURL, qrText, position, buttonDis, loader, updateApi } = this.state;
    const { pathname } = this.props.location; 

    return (
      <>

       { !updateApi ?  <NavigationHeader
          name={'QR Code'} 
          backToNavigation={`${pathname ? stripTrailingSlash(pathname,match) : ''}`}
          />  : null }
        <div className="container-fluid subheader_content">
          <Card className="select_wall mb-3 rounded-0 border-0">
            <Card.Body className="p-0">
              <Row>
                <Col lg={4} className="border-right-lg">
                  <Card className="border-0 rounded-0">
                    <Card.Body className="p-4 card_height">
                      <Form.Group className="form-group" controlId="formBasicEmail">
                        <Form.Label>Enter QR Code Url</Form.Label>
                        <Form.Control
                          type="text"
                          className="text-url-update"
                          value={qrURL}
                          autocomplete="off"
                          onChange={this.onTextQRCode}
                        />
                      </Form.Group>
                      <Form.Group className="form-group" controlId="formBasicEmail">
                        <Form.Label>Display Text</Form.Label>
                        <Form.Control
                          type="text"
                          className="text-url-update"
                          value={qrText}
                          autocomplete="off"
                          placeholder="Enter text to display with QR Code"
                          onChange={this.onqrLabelChange}
                        />
                      </Form.Group>
                      <Form.Group className="form-group" controlId="theme-option">
                        <Form.Label>Text Position</Form.Label>
                        <Select
                          value={positionOption.find(option => option.value === position)}
                          onChange={this.onPositionChange}
                          options={positionOption}
                        />
                      </Form.Group>
                    </Card.Body>
                    <Card.Footer className="bg-transparent d-flex justify-content-end border-0 p-4">
                      <button
                        className="btn btn-outline-dark me-3 btn-min-w"
                        onClick={this.onBack}
                      >
                        <span className="position-relative">Back</span>
                      </button>
                      <Button
                        variant="primary"
                        disabled={ buttonDis } className={`btn btn-primary btn-min-w ${loader ? `spinner spinner-white spinner-right disabled` : null}`}
                        onClick={this.onSaveQRCode}
                        id="Studio_QRCode_App_Users"
                      >
                        Save
                      </Button>
                    </Card.Footer>
                  </Card>
                </Col>
                <Col
                  lg={8}
                  className="d-flex align-items-center justify-content-center"
                >
                  <Card className="border-0 card w-100">
                    <Card.Body className="border-0">
                      <div className="wall_view">
                        <div className="wall_view_wrapper">

                          <div className="qr_wrap011">
                            {position === 'top' ? <>
                              <div className="tb_qr_label"> {qrText}</div>
                            </> : null}
                            <div className="qr_wrap_in00">
                              <DisplayQRCode
                                size={'500'}
                                value={
                                  this.state.qrURL == ""
                                    ? "https://taggbox.com"
                                    : this.state.qrURL
                                }
                              />
                            </div>
                            {position === 'bottom' ? <>
                              <div className="tb_qr_label"> {qrText}</div>
                            </> : null}
                          </div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Card.Body>
          </Card>

        </div>
      </>

    );
  }
}
const mapStateToProps = (state) => { 
  return {
    studioWall: state.studio.studioWall,
    scenes: state.scene,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addApp: (contentMixId, position, appContent, appName, appId, callBack) =>
      dispatch(
        addApp(contentMixId, position, appContent, appName, appId, callBack)
      ),
    updateApp: (contentMixId, sceneContentId, appContent, appId, callBack) => dispatch(updateApp(contentMixId, sceneContentId, appContent, appId, callBack)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QRCode);
